// extracted by mini-css-extract-plugin
export default {"form":"HolzfinderInputLabled_form__Q4Ii0","input":"HolzfinderInputLabled_input__Ak1Tl"};